<template>
    <div class="basic-box">
        <h1>Verify</h1>
        <div>
            Your email is not yet verified. Check your inbox for the
            verification link.
        </div>
        <div class="buttons">
            <Bttn v-if="!triggered" @click="sendVerificationEmail">Resend</Bttn>
        </div>
    </div>
</template>

<script>
import { useUserStore } from "../../stores/userStore";

export default {
    name: "Verify",
    components: {},
    data() {
        return {
            store: null,
            triggered: false,
        };
    },
    mounted() {
        this.store = useUserStore();
    },
    methods: {
        sendVerificationEmail() {
            this.triggered = true;
            this.store.create("/api/email/resend-verification").then(() => {});
        },
    },
};
</script>
